<template>
  <div id="AqtIndexZh">
    <div class="right">
      <SearchIndex ref="child" :style="{height:$route.path=='/zhver'?'100%':'auto'}"></SearchIndex>
    </div>
  </div>
</template>

<script>

export default {
  components: {
    SearchIndex: (re) => require(["@/views/SearchIndex/ZH/Index.vue"], re),
  },
  data() {
    return {
    }
  },
  created() {
    this.$store.dispatch('getZtclass').then(() => {})
  },
  methods: {},
  activated() {
    let that = this
    setTimeout(function () {
      that.$refs.child.getClear();
      that.$loginPd()
    }, 500)
  }

}
</script>
<style lang="less" scoped>
#AqtIndexZh {
  width: 100%;
  height: 100%;
  display: flex;
  background: #ffffff;
  overflow-x: auto;
  justify-content: space-between;

  .right {
    width: 100%;
    height: 100%;
    padding: 2% 8%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

}
</style>
